export default __webpack_public_path__ + "static/media/12.455efc38.png";